/**
 * 班级新增学员
 * @Author:xyguo
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, utils_tool, component_tool } from '@/tool'
import { modelUtils } from "@/utils";
import { WizTableForm } from '../../../common'

let {
  WizContainer, ossFileUtils
} = framework_tool;

class ClassStudentAdd extends WizContainer {
  componentName = 'classStudentAdd';

  constructor(props) {
    super(props);
    this.state = {
      addClassStudentVisible: false,
      personIds:[],
      value: undefined
    };
  }

  _componentDidMount = () => {

  }

  //选择人员弹出框确定按钮事件
  _addClassStudentSubmit = (e,data) => {
    let obj = this.state.value;
    const {id} = this.props;
    let classStudentLists = [];
    let personIdList = [];
    let isRepeat = false;
    if (obj && obj instanceof Array && obj.length > 0) {
      obj.forEach(key => {
          let student={};
          const {personId,orgId,positionId, fullName, userName} = key;
          if (personIdList[personId]){
            wizNotice.warn('学员账号【'+userName+'】,姓名【'+fullName+'】只可选择一个任职，请确认后重试');
            isRepeat = true;
            return;
          }
        personIdList[personId] = personId;
        student={
          classInfoId: id,
          personId,
          orgId,
          positionId,
          classStudentSource:0
        };
        classStudentLists.push(student);
      });
      if (classStudentLists.length && !isRepeat){
        this.doAction({
          path: 'classStudentManagement/add',
          payload: {
            key: 'addClassStudent',
            apiParams: {
              classStudents:classStudentLists
            }
          }
        });
        this.props.changeModal(false);
      }
    }
    if (!isRepeat){
      this.props.changeModal(false);
    }
  };

  _onCancel= (e) =>{
    this.props.changeModal(false);
  };

  setFileData(nextKeys, nextRows) {
    this.setState({
      value: nextKeys
    })
  }

  _render() {

    const {personIds} = this.props;
    let userIdentityConfig = WizTableForm.Config.userIdentity(this, { apiParams: { jobState: 1, disabled: 0, ninPersonIdList: personIds && personIds.length>0 ? personIds : null, isNotAuth: false } });
    let tableFormProps = {
      title: '选择学员',
      showModal:false,
      visible:false,
      showSelectValue: true,
      showSelect:true,
      selectType: 'checkbox',
      initRows: [],
      value: [],
    };


    return <WizTableForm
      {...userIdentityConfig} {...tableFormProps}
     // onSubmit={this._addClassStudentSubmit}
      onSelectedRows={this.setFileData.bind(this)}
    />
  }
}

const mapStateToProps = (state, ownProps) => {
  
  return {
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(ClassStudentAdd);
